/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AllShipmentsFreightClassAnalytics
 */
export interface AllShipmentsFreightClassAnalytics {
  /**
   *
   * @type {string}
   * @memberof AllShipmentsFreightClassAnalytics
   */
  freightClass: string;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsFreightClassAnalytics
   */
  count: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsFreightClassAnalytics
   */
  bookedCount: number;
  /**
   *
   * @type {number}
   * @memberof AllShipmentsFreightClassAnalytics
   */
  avgWeight: number;
}

/**
 * Check if a given object implements the AllShipmentsFreightClassAnalytics interface.
 */
export function instanceOfAllShipmentsFreightClassAnalytics(
  value: object,
): value is AllShipmentsFreightClassAnalytics {
  if (!("freightClass" in value) || value["freightClass"] === undefined)
    return false;
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("bookedCount" in value) || value["bookedCount"] === undefined)
    return false;
  if (!("avgWeight" in value) || value["avgWeight"] === undefined) return false;
  return true;
}

export function AllShipmentsFreightClassAnalyticsFromJSON(
  json: any,
): AllShipmentsFreightClassAnalytics {
  return AllShipmentsFreightClassAnalyticsFromJSONTyped(json, false);
}

export function AllShipmentsFreightClassAnalyticsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AllShipmentsFreightClassAnalytics {
  if (json == null) {
    return json;
  }
  return {
    freightClass: json["freightClass"],
    count: json["count"],
    bookedCount: json["bookedCount"],
    avgWeight: json["avgWeight"],
  };
}

export function AllShipmentsFreightClassAnalyticsToJSON(
  json: any,
): AllShipmentsFreightClassAnalytics {
  return AllShipmentsFreightClassAnalyticsToJSONTyped(json, false);
}

export function AllShipmentsFreightClassAnalyticsToJSONTyped(
  value?: AllShipmentsFreightClassAnalytics | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    freightClass: value["freightClass"],
    count: value["count"],
    bookedCount: value["bookedCount"],
    avgWeight: value["avgWeight"],
  };
}
